<template>
  <div class="l-container l-container-padding">
    <div class="l-footer-content">
      <div class="l-footer-site-map">
        <div class="l-grid l-grid-col3">
          <div class="l-grid-inner">
            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="/">
                    <span class="site-map-text">企業サイト トップ</span>
                  </a>
                </li>
              </ul>
            </div>

            <footer-navigation-about></footer-navigation-about>

            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="/business/">
                    <span class="site-map-text">事業案内</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="l-footer-site-map l-site-map-margin">
        <div class="l-grid l-grid-col3">
          <div class="l-grid-inner">
            <footer-navigation-ir></footer-navigation-ir>

            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="/news/">
                    <span class="site-map-text">ニュース</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="/csr/">
                    <span class="site-map-text">CSR</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="l-footer-site-map l-site-map-margin-large">
        <div class="l-grid l-grid-col3">
          <div class="l-grid-inner">
            <footer-navigation-travel></footer-navigation-travel>

            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="https://career.tabikobo.com/">
                    <span class="site-map-text">採用情報</span>
                  </a>
                </li>
              </ul>
            </div>

            <div class="l-grid-item">
              <ul class="site-map">
                <li class="site-map-item">
                  <a href="https://www.tabikobo.com/policy/">
                    <span class="site-map-text">プライバシーポリシー</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterNavigationAbout from "@/components/molecules/FooterNavigationAbout";
import FooterNavigationIr from "@/components/molecules/FooterNavigationIr";
import FooterNavigationTravel from "@/components/molecules/FooterNavigationTravel";

export default {
  components: {
    FooterNavigationAbout,
    FooterNavigationIr,
    FooterNavigationTravel,
  },
};
</script>
